import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Modal,
  Checkbox,
  Upload,
  message,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import DocumentBox from "../../../components/common/DocumentBox";
import { EditFilled, UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import API_MANAGER from "../../../API";
import axios from "axios";
import { s3PreUrl } from "../../../constants";

function QualificationEdit({
  data,
  qualification,
  qualificationEdit,
  handleQualificationEdit,
  licenceType,
  profileId,
  stateTags,
  existingQualifications,
  onReplaceQualification
}) {
  const [qualificationFrom] = useForm();
  const [showSOA, setShowSOA] = useState(data?.hasSOA || data?.SOADocument || data?.SOAIssueDate);
  const [showVOC, setShowVOC] = useState(data?.hasVOC || data?.VOCDocument || data?.VOCIssueDate || data?.VOCType);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [uploadVOCDocument, setUploadVOCDocument] = useState(false);
  const [uploadSOADocument, setUploadSOADocument] = useState(false);
  const [uploadBackDocument, setUploadBackDocument] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileListSOA, setFileListSOA] = useState([]);
  const [fileListVOC, setFileListVOC] = useState([]);
  const [fileListBack, setFileListBack] = useState([]);
  const [documentDeleted, setDocumentDeleted] = useState(false);
  const [documentBackDeleted, setDocumentBackDeleted] = useState(false);
  const [soaDocumentDeleted, setSoaDocumentDeleted] = useState(false);
  const [vocDocumentDeleted, setVocDocumentDeleted] = useState(false);
  const [countries, setCountries] = useState([]);
  const [vocTypes, setVocTypes] = useState([]);
  const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
  const [duplicateQualification, setDuplicateQualification] = useState(null);

  const getCountries = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "COUNTRY",
        limit: 2000,
        sort: "name",
      });
      setCountries(response?.data?.data?.tags || []);
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  const getVocTypes = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "VOC",
        limit: 2000,
        sort: "name",
      });
      setVocTypes(response?.data?.data?.tags || []);
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  useEffect(() => {
    getCountries();
    getVocTypes();
  }, []);

  const checkDuplicate = (qualificationTypeId) => {
    if (!existingQualifications || !qualificationTypeId) {
      return null;
    }
    // Find duplicate excluding the current qualification being edited
    return existingQualifications.find(
      (qual) => 
        (qual?._id !== data?._id && qual?.id !== data?._id) &&
        (qual?.qualificationType?._id === qualificationTypeId || 
         qual?.qualificationType?.id === qualificationTypeId)
    );
  };

  const onFinish = async (values) => {
    // Check for duplicate qualification (only if qualification type changed)
    const currentQualTypeId = data?.qualificationType?._id || data?.qualificationType?.id;
    const newQualTypeId = values.qualificationType;
    
    if (currentQualTypeId !== newQualTypeId) {
      const duplicateQual = checkDuplicate(newQualTypeId);
      if (duplicateQual) {
        setDuplicateQualification(duplicateQual);
        setDuplicateModalVisible(true);
        return;
      }
    }

    try {
      let documentUrl = data?.uploadedDocument;

      // Handle main document
      if (documentDeleted) {
        documentUrl = ""; // Set empty string to delete document
      } else if (fileList?.length > 0 && fileList[0]?.originFileObj) {
        const dataQualification = {
          extension: fileList[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileList[0].originFileObj.name,
          contentType: fileList[0]?.type,
        };
        const responseQualification = await API_MANAGER.fileUpload(dataQualification);
        await axios.put(
          responseQualification?.data?.data?.url,
          fileList[0]?.originFileObj
        );
        documentUrl = s3PreUrl + responseQualification.data?.data?.key;
      }
      // If neither deleted nor new file uploaded, keep existing document
      values.uploadedDocument = documentUrl;

      //SOA Doc
      let soaDocumentUrl = data?.SOADocument;
      if (soaDocumentDeleted) {
        soaDocumentUrl = ""; // Set empty string to delete SOA document
      } else if (fileListSOA?.length > 0 && fileListSOA[0]?.originFileObj) {
        const dataSOA = {
          extension: fileListSOA[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileListSOA[0].originFileObj.name,
          contentType: fileListSOA[0]?.type,
        };
        const responseSOA = await API_MANAGER.fileUpload(dataSOA);
        await axios.put(
          responseSOA?.data?.data?.url,
          fileListSOA[0]?.originFileObj
        );
        soaDocumentUrl = s3PreUrl + responseSOA.data?.data?.key;
      }
      values.SOADocument = soaDocumentUrl;

      //VOC Doc
      let vocDocumentUrl = data?.VOCDocument;
      if (vocDocumentDeleted) {
        vocDocumentUrl = ""; // Set empty string to delete VOC document
      } else if (fileListVOC?.length > 0 && fileListVOC[0]?.originFileObj) {
        const dataVOC = {
          extension: fileListVOC[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileListVOC[0].originFileObj.name,
          contentType: fileListVOC[0]?.type,
        };
        const responseVOC = await API_MANAGER.fileUpload(dataVOC);
        await axios.put(
          responseVOC?.data?.data?.url,
          fileListVOC[0]?.originFileObj
        );
        vocDocumentUrl = s3PreUrl + responseVOC.data?.data?.key;
      }
      values.VOCDocument = vocDocumentUrl;

      //Back Doc
      let backDocumentUrl = data?.uploadedDocumentBack;
      if (documentBackDeleted) {
        backDocumentUrl = ""; // Set empty string to delete back document
      } else if (fileListBack?.length > 0 && fileListBack[0]?.originFileObj) {
        const dataBack = {
          extension: fileListBack[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileListBack[0].originFileObj.name,
          contentType: fileListBack[0]?.type,
        };
        const responseBack = await API_MANAGER.fileUpload(dataBack);
        await axios.put(
          responseBack?.data?.data?.url,
          fileListBack[0]?.originFileObj
        );
        backDocumentUrl = s3PreUrl + responseBack.data?.data?.key;
      }
      values.uploadedDocumentBack = backDocumentUrl;
      values.profileId = profileId;
      await API_MANAGER.editCandidateQualification(values, data._id);
      message.success("Successfully updated qualification");
      setDocumentDeleted(false);
      setDocumentBackDeleted(false);
      setSoaDocumentDeleted(false);
      setVocDocumentDeleted(false);
      handleQualificationEdit();
    } catch (error) {
      message.error(error?.response?.data?.message?.message);
    }
  };
  const setFields = () => {
    qualificationFrom.setFieldsValue({
      qualificationType: data?.qualificationType?._id,
      licenceType: data?.licenceType?.map((item) => item.id),
      memberId: data?.memberId,
      stateOrCountry: data?.stateOrCountry,
      VOCIssueDate: data?.VOCIssueDate ? dayjs(data?.VOCIssueDate) : null,
      VOCType: data?.VOCType?._id || data?.VOCType?.id,
      SOAIssueDate: data?.SOAIssueDate ? dayjs(data?.SOAIssueDate) : null,
      issueDate: data.issueDate ? dayjs(data?.issueDate) : null,
      expiryDate: data.expiryDate ? dayjs(data?.expiryDate) : null,
      hasVOC: data.hasVOC,
      hasSOA: data.hasSOA,
    });
  };
  const props = {
    name: "file",
    accept: "image/jpg,image/jpeg,.pdf",
    multiple: false,
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const handleDocument = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setDocumentDeleted(false); // Reset delete flag if new file is uploaded
    qualificationFrom.setFieldsValue({
      uploadedDocument: newFileList.length > 0 ? newFileList : undefined
    });
    qualificationFrom.validateFields(['uploadedDocument']);
  };
  const handleSOADocument = ({ fileList: newFileList }) => {
    setFileListSOA(newFileList);
    setSoaDocumentDeleted(false); // Reset delete flag
    qualificationFrom.setFieldsValue({
      SOADocument: newFileList.length > 0 ? newFileList : undefined
    });
    qualificationFrom.validateFields(['SOADocument']);
  };
  const handleVOCDocument = ({ fileList: newFileList }) => {
    setFileListVOC(newFileList);
    setVocDocumentDeleted(false); // Reset delete flag
    qualificationFrom.setFieldsValue({
      VOCDocument: newFileList.length > 0 ? newFileList : undefined
    });
    qualificationFrom.validateFields(['VOCDocument']);
  };
  const handleBackDocument = ({ fileList: newFileList }) => {
    setFileListBack(newFileList);
    setDocumentBackDeleted(false); // Reset delete flag
  };

  const handleDeleteDocument = (type) => {
    Modal.confirm({
      title: "Delete Document",
      content: "Are you sure you want to delete this document?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        if (type === "main") {
          setDocumentDeleted(true);
          setUploadDocument(false);
          setFileList([]);
        } else if (type === "back") {
          setDocumentBackDeleted(true);
          setUploadBackDocument(false);
          setFileListBack([]);
        } else if (type === "soa") {
          setSoaDocumentDeleted(true);
          setUploadSOADocument(false);
          setFileListSOA([]);
        } else if (type === "voc") {
          setVocDocumentDeleted(true);
          setUploadVOCDocument(false);
          setFileListVOC([]);
        }
        message.success("Document marked for deletion. Click Update to save changes.");
      },
    });
  };
  useEffect(() => {
    setFields();
    const hasSOAData = data?.hasSOA || data?.SOADocument || data?.SOAIssueDate;
    const hasVOCData = data?.hasVOC || data?.VOCDocument || data?.VOCIssueDate || data?.VOCType;
    setShowSOA(hasSOAData);
    setShowVOC(hasVOCData);
    setDocumentDeleted(false);
    setDocumentBackDeleted(false);
    setSoaDocumentDeleted(false);
    setVocDocumentDeleted(false);
    setUploadDocument(false);
    setUploadBackDocument(false);
    setUploadSOADocument(false);
    setUploadVOCDocument(false);
    setFileList([]);
    setFileListBack([]);
    setFileListSOA([]);
    setFileListVOC([]);
  }, [data]);
  return (
    <>
      <Modal
        centered
        footer={false}
        open={qualificationEdit}
        title={"Qualification Edit"}
        className="resumeModal"
        onCancel={() => {
          handleQualificationEdit();
          setDocumentDeleted(false);
          setDocumentBackDeleted(false);
          setSoaDocumentDeleted(false);
          setVocDocumentDeleted(false);
          setUploadDocument(false);
          setUploadBackDocument(false);
          setUploadSOADocument(false);
          setUploadVOCDocument(false);
          setFileList([]);
          setFileListBack([]);
          setFileListSOA([]);
          setFileListVOC([]);
        }}
      >
        <Form form={qualificationFrom} layout="vertical" onFinish={onFinish}>
          <Row className="containner">
            <Col xs={18}>
              <Form.Item
                label="Qualification/Certification/Ticket/Licence*"
                name="qualificationType"
              >
                <Select
                  className=""
                  placeholder="Qualification"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {qualification?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e?.id}>
                        {e?.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row className="containner">
            <Col xs={18}>
              <Form.Item
                label="Document*"
                name="uploadedDocument"
                rules={[
                  {
                    validator: () => {
                      const hasExistingDoc = data?.uploadedDocument && !documentDeleted;
                      const hasNewFile = fileList.length > 0;
                      if (!hasExistingDoc && !hasNewFile) {
                        return Promise.reject(new Error('Please upload document'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                {uploadDocument || documentDeleted || !data?.uploadedDocument ? (
                  <Upload {...props} onChange={handleDocument}>
                    <Button icon={<UploadOutlined />}>Upload {documentDeleted ? "New " : ""}Document</Button>
                  </Upload>
                ) : (
                  <DocumentBox
                    date={data?.issueDate}
                    url={data?.uploadedDocument}
                  />
                )}
              </Form.Item>
              {documentDeleted && (
                <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                  <p>Previous document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                </div>
              )}
            </Col>
            <Col className="editResume" xs={6}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                {!uploadDocument && !documentDeleted && data?.uploadedDocument && (
                  <>
                    <Tooltip title="Delete document">
                      <DeleteOutlined 
                        onClick={() => {
                          handleDeleteDocument("main");
                          setTimeout(() => {
                            qualificationFrom.validateFields(['uploadedDocument']);
                          }, 0);
                        }}
                        style={{ 
                          color: "#ff4d4f", 
                          fontSize: "18px", 
                          cursor: "pointer" 
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Edit document">
                      <EditFilled 
                        onClick={() => setUploadDocument(true)}
                        style={{ fontSize: "18px", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="containner">
            <Col xs={18}>
              <Form.Item
                label="Back Document"
                name="uploadedDocumentBack"
              >
                {uploadBackDocument || documentBackDeleted || !data?.uploadedDocumentBack ? (
                  <Upload {...props} onChange={handleBackDocument}>
                    <Button icon={<UploadOutlined />}>Upload {documentBackDeleted ? "New " : ""}Back Document</Button>
                  </Upload>
                ) : (
                  <DocumentBox
                    date={data?.issueDate}
                    url={data?.uploadedDocumentBack}
                  />
                )}
              </Form.Item>
              {documentBackDeleted && (
                <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                  <p>Previous back document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                </div>
              )}
            </Col>
            <Col className="editResume" xs={6}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                {!uploadBackDocument && !documentBackDeleted && data?.uploadedDocumentBack && (
                  <>
                    <Tooltip title="Delete back document">
                      <DeleteOutlined 
                        onClick={() => handleDeleteDocument("back")}
                        style={{ 
                          color: "#ff4d4f", 
                          fontSize: "18px", 
                          cursor: "pointer" 
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Edit back document">
                      <EditFilled 
                        onClick={() => setUploadBackDocument(true)}
                        style={{ fontSize: "18px", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="containner" gutter={24}>
            <Col xs={12}>
              <Form.Item label="Member No./ID*" name="memberId">
                <Input placeholder="Member no./id" />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item
                label="Licence Type/Class/Category"
                name="licenceType"
              >
                <Select
                  className=""
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="Licence Type/Class/Category"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {licenceType?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item label="State/Country*" name="stateOrCountry">
                <Select
                  className=""
                  maxTagCount="responsive"
                  placeholder="State/Country"
                  showSearch
                  filterOption={(input, option) => {
                    const searchText = input.toLowerCase().trim();
                    if (!searchText) return true;
                    
                    const optionValue = String(option?.value || '').toLowerCase();
                    if (optionValue.indexOf(searchText) >= 0) {
                      return true;
                    }
                    
                    if (option?.children) {
                      if (typeof option.children === 'string') {
                        return option.children.toLowerCase().indexOf(searchText) >= 0;
                      }
                      if (React.isValidElement(option.children)) {
                        const childrenText = String(option.children.props?.children || '');
                        if (childrenText.toLowerCase().indexOf(searchText) >= 0) {
                          return true;
                        }
                      }
                    }
                    
                    return false;
                  }}
                >
                  <Select.OptGroup 
                    label={<span style={{ color: '#000', fontWeight: 'bold' }}>State</span>}
                  >
                    {stateTags && stateTags.length > 0 ? stateTags.map((e, key) => {
                      return (
                        <Select.Option key={`state-${key}`} value={e?.name || e?.id}>
                          {e?.name}
                        </Select.Option>
                      );
                    }) : null}
                  </Select.OptGroup>
                  <Select.OptGroup 
                    label={<span style={{ color: '#000', fontWeight: 'bold' }}>Country</span>}
                  >
                    {countries?.map((e, key) => {
                      return (
                        <Select.Option key={`country-${key}`} value={e.name}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select.OptGroup>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Issue Date*" 
                name="issueDate"
                dependencies={['expiryDate']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const expiryDate = getFieldValue('expiryDate');
                      const hasIssueDate = value !== null && value !== undefined;
                      const hasExpiryDate = expiryDate !== null && expiryDate !== undefined;
                      if (!hasIssueDate && !hasExpiryDate) {
                        return Promise.reject(new Error('Please select at least issue date or expiry date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select issue date"
                />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Expiry Date*" 
                name="expiryDate"
                dependencies={['issueDate']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const issueDate = getFieldValue('issueDate');
                      const hasIssueDate = issueDate !== null && issueDate !== undefined;
                      const hasExpiryDate = value !== null && value !== undefined;
                      if (!hasIssueDate && !hasExpiryDate) {
                        return Promise.reject(new Error('Please select at least issue date or expiry date'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select expiry date"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item name="hasSOA">
                <Checkbox
                  checked={showSOA}
                  onChange={() => {
                    const newValue = !showSOA;
                    setShowSOA(newValue);
                    qualificationFrom.setFieldsValue({ hasSOA: newValue });
                    if (newValue) {
                      setTimeout(() => {
                        qualificationFrom.validateFields(['SOADocument', 'SOAIssueDate']);
                      }, 0);
                    } else {
                      setFileListSOA([]);
                      qualificationFrom.setFieldsValue({ SOADocument: undefined, SOAIssueDate: undefined });
                      qualificationFrom.validateFields(['SOADocument', 'SOAIssueDate']);
                    }
                  }}
                >
                  Statement of Attainment
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
          {showSOA && (
            <Row className="containner">
              <Col xs={18}>
                <Form.Item
                  label="SOA Document*"
                  name="SOADocument"
                  dependencies={['hasSOA']}
                  rules={[
                    {
                      validator: () => {
                        const hasExistingDoc = data?.SOADocument && !soaDocumentDeleted;
                        const hasNewFile = fileListSOA.length > 0;
                        if (showSOA && !hasExistingDoc && !hasNewFile) {
                          return Promise.reject(new Error('Please upload SOA document'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  {uploadSOADocument || soaDocumentDeleted || !data?.SOADocument ? (
                    <Upload {...props} onChange={handleSOADocument}>
                      <Button icon={<UploadOutlined />}>Upload {soaDocumentDeleted ? "New " : ""}SOA Document</Button>
                    </Upload>
                  ) : (
                    <DocumentBox
                      date={data?.SOAIssueDate}
                      url={data?.SOADocument}
                    />
                  )}
                </Form.Item>
                {soaDocumentDeleted && (
                  <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                    <p>Previous SOA document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                  </div>
                )}
              </Col>
              <Col className="editResume" xs={6}>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  {!uploadSOADocument && !soaDocumentDeleted && data?.SOADocument && (
                    <>
                      <Tooltip title="Delete SOA document">
                        <DeleteOutlined 
                          onClick={() => {
                            handleDeleteDocument("soa");
                            setTimeout(() => {
                              qualificationFrom.validateFields(['SOADocument']);
                            }, 0);
                          }}
                          style={{ 
                            color: "#ff4d4f", 
                            fontSize: "18px", 
                            cursor: "pointer" 
                          }}
                        />
                      </Tooltip>
                      <EditFilled 
                        onClick={() => setUploadSOADocument(true)}
                        style={{ fontSize: "18px", cursor: "pointer" }}
                      />
                    </>
                  )}
                </div>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Issue Date*" 
                  name="SOAIssueDate"
                  dependencies={['hasSOA']}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (showSOA) {
                          if (!value) {
                            return Promise.reject(new Error('Please select SOA issue date'));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    placeholder="Select issue date"
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12}>
              <Form.Item name="hasVOC">
                <Checkbox
                  checked={showVOC}
                  onChange={() => {
                    const newValue = !showVOC;
                    setShowVOC(newValue);
                    qualificationFrom.setFieldsValue({ hasVOC: newValue });
                    if (newValue) {
                      setTimeout(() => {
                        qualificationFrom.validateFields(['VOCDocument', 'VOCIssueDate', 'VOCType']);
                      }, 0);
                    } else {
                      setFileListVOC([]);
                      qualificationFrom.setFieldsValue({ VOCDocument: undefined, VOCIssueDate: undefined, VOCType: undefined });
                      qualificationFrom.validateFields(['VOCDocument', 'VOCIssueDate', 'VOCType']);
                    }
                  }}
                >
                  Verification of Competency
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
          {showVOC && (
            <Row className="containner">
              <Col xs={18}>
                <Form.Item
                  label="VOC Document*"
                  name="VOCDocument"
                  dependencies={['hasVOC']}
                  rules={[
                    {
                      validator: () => {
                        const hasExistingDoc = data?.VOCDocument && !vocDocumentDeleted;
                        const hasNewFile = fileListVOC.length > 0;
                        if (showVOC && !hasExistingDoc && !hasNewFile) {
                          return Promise.reject(new Error('Please upload VOC document'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  {uploadVOCDocument || vocDocumentDeleted || !data?.VOCDocument ? (
                    <Upload {...props} onChange={handleVOCDocument}>
                      <Button icon={<UploadOutlined />}>Upload {vocDocumentDeleted ? "New " : ""}VOC Document</Button>
                    </Upload>
                  ) : (
                    <DocumentBox
                      date={data?.VOCIssueDate}
                      url={data?.VOCDocument}
                    />
                  )}
                </Form.Item>
                {/* {vocDocumentDeleted && (
                  <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                    <p>Previous VOC document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                  </div>
                )} */}
              </Col>
              <Col className="editResume" xs={6}>
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  {!uploadVOCDocument && !vocDocumentDeleted && data?.VOCDocument && (
                    <>
                      <Tooltip title="Delete VOC document">
                        <DeleteOutlined 
                          onClick={() => {
                            handleDeleteDocument("voc");
                            setTimeout(() => {
                              qualificationFrom.validateFields(['VOCDocument']);
                            }, 0);
                          }}
                          style={{ 
                            color: "#ff4d4f", 
                            fontSize: "18px", 
                            cursor: "pointer" 
                          }}
                        />
                      </Tooltip>
                      <EditFilled 
                        onClick={() => setUploadVOCDocument(true)}
                        style={{ fontSize: "18px", cursor: "pointer" }}
                      />
                    </>
                  )}
                </div>
              </Col>
            </Row>
          )}
          {showVOC && (
            <Row gutter={24}>
              <Col xs={12}>
                <Form.Item 
                  label="Verification Type*" 
                  name="VOCType"
                  dependencies={['hasVOC']}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (showVOC) {
                          if (!value) {
                            return Promise.reject(new Error('Please select verification type'));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Select
                    className=""
                    placeholder="Select Verification Type"
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {vocTypes?.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e.id}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item 
                  label="Issue Date*" 
                  name="VOCIssueDate"
                  dependencies={['hasVOC']}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (showVOC) {
                          if (!value) {
                            return Promise.reject(new Error('Please select VOC issue date'));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    placeholder="Select issue date"
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={24} className="buttonCol">
              <Button className="btn1" htmlType="submit">
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        className="candidateDeleteModal"
        centered
        open={duplicateModalVisible}
        onCancel={() => {
          setDuplicateModalVisible(false);
          setDuplicateQualification(null);
        }}
        footer={null}
        title="Duplicate Qualification"
      >
        <Row className="header">
          <Col>
            <p className="desc">
              You&apos;ve already added a similar qualification.
              <br />
              Do you want to continue replacing the previous qualification with a new one?
            </p>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16} justify={"end"}>
          <Col>
            <Button
              className="cancelBtn"
              onClick={() => {
                setDuplicateModalVisible(false);
                setDuplicateQualification(null);
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className="confirmBtn"
              onClick={() => {
                setDuplicateModalVisible(false);
                handleQualificationEdit(); // Close current edit modal
                if (onReplaceQualification && duplicateQualification) {
                  onReplaceQualification(duplicateQualification); // Open edit modal for duplicate
                }
                setDuplicateQualification(null);
              }}
            >
              Replace
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
export default QualificationEdit;
